import { GroupJoinRequestRecord, GroupMemberRecord } from 'api/fundInvestmentManagement';

export interface GroupMemberRow {
  memberEmail: string;
  memberName: string;
  memberAvatar?: string;
  order: number;
  orderChecked?: boolean;
  investedAmount?: string; // member["investedAmount"] from blob
  contributionAmount?: number;
  amountInvestedTillDate?: number;
  contribution?: number;
  pendingContributionAmount?: number;
  paymentStatus: string;
  vivuyeStatus: string;
  adminConfirmed: string;
  amount: number;
  isApproved?: boolean;
  expenseId?: string;
  transactionDate?: string;
  version?: number;
  lastUpdatedDateTime?: string;
}

export interface BuyRequestRow extends GroupJoinRequestRecord {}

export interface GroupReportDataState {
  members: GroupMemberRow[];
  buyRequests: BuyRequestRow[];
  loading: boolean;
  error: string | null;
  permissionDenied: boolean;
}

export interface GroupReportActions {
  refresh: () => Promise<void>;
  addMember: (payload: { memberEmail: string; memberName: string; memberAvatar?: string }) => Promise<void>;
  removeMember: (memberEmail: string) => Promise<void>;
  reorderMembers: (orderUpdates: Array<{ memberEmail: string; order: number }>) => Promise<void>;
}

export function mapMemberRecord(record: GroupMemberRecord): GroupMemberRow {
  const parsedPendingContributionAmount = Number(record.pendingContributionAmount);

  return {
    memberEmail: record.memberEmail,
    memberName: record.memberName,
    memberAvatar: record.memberAvatar,
    order: record.order,
    orderChecked: record.orderChecked ?? false,
    investedAmount: record.investedAmount,
    contributionAmount: record.contributionAmount,
    amountInvestedTillDate: record.amountInvestedTillDate,
    contribution: record.contribution,
    pendingContributionAmount: Number.isFinite(parsedPendingContributionAmount) ? parsedPendingContributionAmount : undefined,
    paymentStatus: record.paymentStatus || 'NA',
    vivuyeStatus: record.vivuyeStatus || 'NA',
    adminConfirmed: record.adminConfirmed || record.adminStatus || 'NA',
    amount:
      record.contributionAmount ??
      record.amountInvestedTillDate ??
      record.contribution ??
      record.amount ??
      record.paidAmount ??
      0,
    isApproved: record.isApproved,
    expenseId: record.expenseId,
    transactionDate: record.transactionDate,
    version: record.version,
    lastUpdatedDateTime: record.lastUpdatedDateTime
  };
}